import React from 'react';
import { useTranslation } from 'react-i18next';
import { VehicleDetails as VehicleDetailsType } from 'cpes-common';
import { getContractBasedDataSelector, useGetContractBasedApiData } from '@cp-shared-19/frontend-integration';
import { Accordion } from '@vwfs-bronson/bronson-react';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { RootState } from 'store/rootReducer';
import { fetchVehicleDetails } from './VehicleDetailsSlice';
import { SingleVehicleDetails } from './single-vehicle-details';

type VehicleDetailsProps = {
    contractId: string;
    link: string;
};

const VehicleDetailsComponent: React.FC<{ vehicles?: VehicleDetailsType[] }> = ({ vehicles }) => {
    if (!vehicles || vehicles.length < 1) {
        return null;
    }

    return (
        <>
            {vehicles.map(vehicle => (
                <SingleVehicleDetails key={vehicle.vinCode} details={vehicle} numberOfCars={vehicles.length} />
            ))}
        </>
    );
};

const VehicleDetailsWithWrappers = withLoadingAndNoConnectionHandler(VehicleDetailsComponent);

export const VehicleDetailsDataSelector = getContractBasedDataSelector((state: RootState) => state.vehicleDetails);

export const VehicleDetails: React.FC<VehicleDetailsProps> = ({ contractId, link }) => {
    const { t } = useTranslation('contracts');

    const { data: vehicles, isLoading, loadingError } = useGetContractBasedApiData(
        contractId,
        fetchVehicleDetails,
        VehicleDetailsDataSelector,
        link,
    );

    return (
        <Accordion.Item title={t('vehicleDetails.headline')}>
            <div>
                <VehicleDetailsWithWrappers isLoading={isLoading} hasError={!!loadingError} vehicles={vehicles} />
            </div>
        </Accordion.Item>
    );
};
